import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import profileImage from "../../assets/images/profile.png";

export default function Hero() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="min-h-[80vh] flex items-center"
    >

      <div className="grid md:grid-cols-2 gap-12 items-center w-full">

        {/* LEFT SIDE */}

        <div>

          <p className="text-zinc-400 mb-4 tracking-widest">
            FULL-STACK DEVELOPER
          </p>

          <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6">
            Manish
            <br />
            Kumar Sah
          </h1>

          <p className="text-zinc-300 text-lg leading-relaxed max-w-xl">
            Building practical software systems, automation tools,
            modern web applications and productivity-focused solutions
            using React, Python and Flask.
          </p>

          {/* BUTTONS */}

          <div className="flex gap-4 mt-8 flex-wrap">

            <a
              href="https://github.com/developwithmanish"
              target="_blank"
              rel="noreferrer"
              className="bg-white text-black px-6 py-3 rounded-2xl font-semibold hover:scale-105 transition"
            >
              GitHub
            </a>

            <a
              href="/resume.pdf"
              className="border border-zinc-700 px-6 py-3 rounded-2xl hover:bg-zinc-900 transition"
            >
              Resume
            </a>

          </div>

          {/* SOCIAL ICONS */}

          <div className="flex gap-5 mt-10 text-2xl text-zinc-400">

            <a
              href="https://github.com/developwithmanish"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white hover:-translate-y-1 transition duration-300"
            >
              <FaGithub />
            </a>

            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white hover:-translate-y-1 transition duration-300"
            >
              <FaLinkedin />
            </a>

            <a
              href="mailto:developwithmanish@gmail.com"
              className="hover:text-white hover:-translate-y-1 transition duration-300"
            >
              <FaEnvelope />
            </a>

          </div>

        </div>

        {/* RIGHT SIDE */}

        <div className="flex justify-center">

          <div className="relative">

            <img
              src={profileImage}
              alt="Manish"
              className="w-[320px] h-[320px] md:w-[420px] md:h-[420px] object-cover rounded-3xl border border-zinc-800 shadow-2xl hover:scale-[1.02] transition duration-500"
            />

          </div>

        </div>

      </div>

    </motion.section>
  );
}